import { PricingError } from '@guest-widgets/shared/src/types/product/cartItemPrice';
import { PublicMoney, Quantity } from '@guest-widgets/shared/src/types/product/miscellaneous';

export interface UpsellPricing {
  upsellId: string;
  totals: TotalPrice;
  error?: PricingError;
  isValid: boolean;
}

interface TotalPrice {
  subtotal: PublicMoney;
  total: PublicMoney;
}

export interface UpsellParent {
  productId: string;
  cartId: string;
}

export interface UpsellToValidate {
  parent: {
    lineId: string;
  };
  product: {
    productId: number;
  };
  guestTypes?: Quantity;
  start?: string;
  end?: string;
}

export enum AttachmentType {
  OPTIONAL = 'optional',
  PRESELECTED = 'preselected',
  REQUIRED = 'required',
}
